import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { Field, reduxForm, SubmissionError, reset } from 'redux-form'
import { connect } from 'react-redux'
import { PulseLoader } from 'halogen'
import { SIGNUP_REQUEST } from '../../actions/actions'
import { appendToFormData } from '../../helpers/utility'
import { Row, Grid, Form, Button, FormGroup, InputGroup } from '@sketchpixy/rubix'

class TeacherSignup extends Component {
  usernameInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="username">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-user-circle-o" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام کاربری"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  passwordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="password">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="password"
            className="border-focus-blue"
            placeholder="گذرواژه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  confirmPasswordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="confirmPassword">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="password"
            className="border-focus-blue"
            placeholder="تائید گذرواژه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  firstName = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="firstName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  lastName = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="lastName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام خانوادگی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  email = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="email">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-envelope" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="email"
            className="border-focus-blue"
            placeholder="ایمیل"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  mobile = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="mobile">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-mobile" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="شماره موبایل"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  secondPhone = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="secondPhone">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-phone" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="شماره تماس دوم"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  address = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="address">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-map-marker" aria-hidden="true" />
          </InputGroup.Addon>
          <textarea
            type="text"
            className="border-focus-blue"
            placeholder="نشانی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  info = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <textarea
            type="text"
            className="border-focus-blue"
            placeholder="توضیحات"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  onSubmit = values => {
    const { dispatch, updateParent } = this.props
    let formData = appendToFormData(values)
    return new Promise((resolve, reject) => {
      dispatch({
        type: SIGNUP_REQUEST,
        formData,
        resolve,
        reject,
        userType: 'TEACHER'
      })
    })
      .then(data => {
        if (updateParent) {
          updateParent(data)
          dispatch(reset('TeacherSignup'))
        } else {
          this.redirect()
        }
      })
      .catch(response => {
        throw new SubmissionError({
          _error: response.general_errors[0],
          ...response.form_errors
        })
      })
  }

  redirect = () => browserHistory.push('/signup/success')

  render() {
    const { handleSubmit, error } = this.props
    return (
      <div>
        <div
          style={{
            padding: 25,
            paddingTop: 0,
            paddingBottom: 0,
            margin: 'auto',
            marginBottom: 25,
            marginTop: 25
          }}>
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            <Field name="first_name" component={this.firstName} />
            <Field name="last_name" component={this.lastName} />
            <Field name="username" component={this.usernameInput} autoComplete="username" />
            <Field name="email" component={this.email} />

            {/*<FormGroup controlId="info">
              <InputGroup bsSize="large">
                <InputGroup.Addon>
                  <i className="fa fa-neuter" aria-hidden="true" />
                </InputGroup.Addon>
                <Field name="gender" component="select">
                  <option value="female" selected>زن</option>
                  <option value="male">مرد</option>
                </Field>
              </InputGroup>
            </FormGroup>*/}

            {/*<Field name="national_number" component={this.nationalNumber} />*/}

            {/*<Field name="phone_number" component={this.mobile} />*/}

            {/*<Field name="address" component={this.address} />*/}

            {/*<Field name="info" component={this.info} />*/}

            {/*<Field name="secondary_phone" component={this.secondPhone} />*/}

            <Field name="password" component={this.passwordInput} autoComplete="password" />
            <Field name="confirm_password" component={this.confirmPasswordInput} />
            <FormGroup>
              <Grid>
                <Row style={{ textAlign: 'center', padding: '5px' }}>
                  {error && <strong>{error}</strong>}
                </Row>
                <Row>
                  <div className="auth-buttons-container">
                    {!this.props.aSyncCall ? (
                      <Button
                        style={{ marginLeft: 10 }}
                        lg
                        type="submit"
                        bsStyle="primary"
                        className="auth-buttons">
                        عضویت
                      </Button>
                    ) : (
                      <div
                        style={{
                          height: 45,
                          display: 'flex',
                          alignContent: 'center',
                          alignItems: 'center',
                          marginLeft: 10
                        }}>
                        <PulseLoader color="#275C8A" size="10px" />
                      </div>
                    )}
                    <Button
                      lg
                      bsStyle="primary"
                      outlined
                      className="auth-buttons"
                      onClick={() => browserHistory.push('/')}>
                      بازگشت
                    </Button>
                  </div>
                </Row>
              </Grid>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}
  if (!values.username) {
    errors.username = 'نام کاربری اجباری است'
  }
  if (!values.last_name) {
    errors.last_name = 'نام خانوادگی اجباری است'
  }
  if (!values.first_name) {
    errors.first_name = 'نام اجباری است'
  }
  if (!values.email) {
    errors.email = 'ایمیل اجباری است'
  }
  if (!values.phone_number) {
    errors.phone_number = 'شماره موبایل اجباری است'
  }
  if (!values.password) {
    errors.password = 'گذرواژه اجباری است'
  }
  if (values.password !== values.confirm_password || !values.password) {
    errors.confirm_password = 'گذرواژه ها یکسان نیست'
  }
  return errors
}

TeacherSignup = reduxForm({
  form: 'TeacherSignup',
  validate
})(TeacherSignup)

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    aSyncCall: state.auth.aSyncCall,
    initialValues: {
      // gender: "female"
    }
  }
}

export default connect(mapStateToProps)(TeacherSignup)



// WEBPACK FOOTER //
// ./src/components/teacher/TeacherSignup.js